import { useTranslation } from "react-i18next";
import BackButtonWrapper from "../../components/button/BackButton/wrapper";
import SearchEvacuationReportCard from "../../components/card/SearchEvacuationReportCard";
import { useState } from "react";
import { PAGE_SIZE } from "../../constants/common";
import Loader from "../../components/loader";
import EvacuationReportTable from "../../components/table/EvacuationReportTable";

const EvacuationReport = () => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);

  const [search, setSearch] = useState("");

  const [allEvacuationReports, setAllEvacuationReports] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("evacuationReport")}
        </h1>
      </BackButtonWrapper>

      <SearchEvacuationReportCard
        setAllEvacuationReports={setAllEvacuationReports}
        setIsLoading={setIsLoading}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        pageSize={pageSize}
        setPage={setPage}
      />

      {isLoading ? (
        <div className="flex justify-center lg:col-span-3">
          <Loader />
        </div>
      ) : (
        <EvacuationReportTable
          allEvacuationReports={allEvacuationReports}
          page={page}
          pages={pages}
          setPage={setPage}
          search={search}
          setSearch={setSearch}
          count={count}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      )}
    </div>
  );
};

export default EvacuationReport;
